import httpService from "../../Service/httpServiceInterfase";

const controller = "Interfase";

export const getDatosCliente = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getDatosCliente/${id}/${idPac}`);
	return res.data;
};

export const saveCliente = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveCliente`, {
		...data,
	});
	return res;
};